import {
  NodeBasicPage,
  NodeLandingPage,
  NodeArticle,
  NodeFAQ,
  NodeFrontPage,
  NodeTestimonial,
  NodeMunicipality,
  NodeSuccessPage,
} from '../implementations';

const mappers = {
  basic_page: NodeBasicPage,
  landing_page: NodeLandingPage,
  article: NodeArticle,
  municipality: NodeMunicipality,
  front_page: NodeFrontPage,
  faq: NodeFAQ,
  testimonial: NodeTestimonial,
  success_page: NodeSuccessPage,
};

export default mappers;
